import { useState } from "react";
import "./menu.css"
import { FaHouse } from "react-icons/fa6";
import { FaUserLarge } from "react-icons/fa6";
import { FaProductHunt } from "react-icons/fa6";
import { FaBasketShopping } from "react-icons/fa6";
import { Link } from "react-router-dom";

function ResponsiveMenu() {
    const [resMenu, setResMenu] = useState([
        {id : 1 , link: "/", txt: "خانه", active: true , icon : FaHouse},
        {id : 2 , link: "/products", txt: "محصولات", active: false , icon : FaProductHunt},
        {id : 3 , link: "/profile", txt: "پنل", active: false , icon : FaUserLarge},
        {id : 4 , link: "/cart", txt: "سبدخرید", active: false , icon : FaBasketShopping},
    ])
    const handlePress = (id) => {
        const update = resMenu.map((item) => {
            if(item.id == id){
                return {...item , active : true}
            }else{
                return {...item , active : false}
            }
        })
        setResMenu(update)
    }
    return (
        <div className="responsive-menu">
            <div className="responsive-menu-container">
                <ul>
                    {
                        resMenu.map((item, i) => {
                            return (
                                <li key={i} className={item.active ? "res-menu-item active" : "res-menu-item"}>
                                    <Link to={item.link} onClick={() => handlePress(item.id)}>
                                        <item.icon size={18} />
                                        <span>{item.txt}</span>
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        </div>
    )
}

export default ResponsiveMenu;